import React from 'react';
import { IIconProps } from '../interfaces';

const MobileMenuIcon = (props: IIconProps) => {

    return (
        <svg
            width={ props.width }
            height={ props.width }
            className={ props.classes }
            viewBox="0 0 45 45"
            xmlns="http://www.w3.org/2000/svg"
            fill={ props.color ? props.color : "none"}>
            <rect x="-0.5" y="0.5" width="44" height="44" rx="22" transform="matrix(-1 0 0 1 44 0)" fill={ props.color ? props.color : "none"} stroke="#DBDBDB"/>
            <path d="M17 20.1871C17.0005 20.6117 17.3572 20.9555 17.7974 20.956H20.3046C20.7449 20.9555 21.1021 20.6116 21.1026 20.1871V17.7694C21.1021 17.3449 20.7449 17.0005 20.3046 17H17.7974C17.3571 17.0005 17.0005 17.3449 17 17.7694V20.1871Z" stroke="#4A4A4A" strokeWidth="0.9"/>
            <path d="M28.2021 17.0024H25.6954C25.2551 17.0029 24.898 17.3468 24.8975 17.7719V20.1895V20.1891C24.898 20.6136 25.2551 20.958 25.6954 20.9585H28.2026H28.2021C28.6424 20.958 28.9995 20.6136 29 20.1891V17.7714V17.7719C28.9995 17.3468 28.6424 17.0029 28.2021 17.0024L28.2021 17.0024Z" stroke="#4A4A4A" strokeWidth="0.9"/>
            <path d="M17 28.231C17.0005 28.6556 17.3572 28.9995 17.7974 29H20.3046C20.7449 28.9995 21.1021 28.6555 21.1026 28.231V25.813C21.1021 25.3884 20.7449 25.0444 20.3046 25.0439H17.7974C17.3571 25.0444 17.0005 25.3884 17 25.813V28.231Z" stroke="#4A4A4A" strokeWidth="0.9"/>
            <path d="M28.2021 29C28.6424 28.9995 28.9995 28.6555 29 28.231V25.813C28.9995 25.3884 28.6424 25.0444 28.2021 25.0439H25.6954C25.2551 25.0444 24.898 25.3884 24.8975 25.813V28.231C24.898 28.6556 25.2551 28.9995 25.6954 29H28.2021Z" stroke="#4A4A4A" strokeWidth="0.9"/>
            <title>{ props.title }</title>

        </svg>)
};

export default MobileMenuIcon;
